import React, { useState } from 'react'
import { useMutation } from '@apollo/client'
import { Modal } from 'react-bootstrap'
import { Button, Form } from 'semantic-ui-react'
import { BLOCK_EXPERT, UNBLOCK_EXPERT } from '../../graphql/user'
import CustomLink from '../CustomLink'

const BlockExpertButton = ({ expert }) => {
    const [show, setShow] = useState(false)
    const [blockReason, setBlockReason] = useState('')
    const [blockExpert] = useMutation(BLOCK_EXPERT, {
        onCompleted: () => setShow(false),
    })
    const [unblockExpert] = useMutation(UNBLOCK_EXPERT)
    if (expert.expert.isBlocked) {
        return (
            <CustomLink
                onClick={() => unblockExpert({ variables: { id: expert.id } })}
            >
                Unblock this expert
            </CustomLink>
        )
    }
    return (
        <>
            <CustomLink onClick={() => setShow(true)}>
                Block this exeprt
            </CustomLink>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                centered
                style={{ zIndex: 9999 }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {`Are you sure you wish to block ${
                            expert.fullName || expert.email
                        }?`}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        {`Blocked experts are no longer eligible to be invited to
                        Dexter projects and will not appear in search results in
                        the Dexter client portal. ${expert.expert.numPending} pending invitations will be
                        expired upon blocking that person`}
                    </p>
                    <Form>
                        <Form.TextArea
                            label="Reason for blocking"
                            value={blockReason}
                            onChange={(e) => setBlockReason(e.target.value)}
                        />
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => setShow(false)}>Cancel</Button>
                    <Button
                        primary
                        onClick={() =>
                            blockExpert({ variables: { id: expert.id, reason: blockReason } })
                        }
                    >
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default BlockExpertButton
